import { FC } from 'react'

import OfferCard from './OfferCard'
import { OfferSummary, Tag } from 'common/types/responses'

type OffersByTagType = {
  offers: OfferSummary[]
  tag: Tag
}

const OffersByTag: FC<OffersByTagType> = ({ offers, tag }) => {
  // Filter out null/undefined offers
  const validOffers = offers?.filter((offer) => offer != null) ?? []

  return (
    <div className='mt-2 mt-md-22'>
      <h4 id={tag.id} style={{ scrollMarginTop: '230px' }}>
        {tag.name}
      </h4>

      <div className='row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xxl-4 mt-6'>
        {validOffers.map((offer) => (
          <div key={offer.id} className='col d-flex mb-4 mb-md-10 px-3'>
            <OfferCard offerInfo={offer} tag={tag} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default OffersByTag
